import { getMultiselectEditorTemplate, MultiselectEditor, agMultiselectEditorStyles, } from '@genesislcap/grid-pro';
/**
 * @tagname %%prefix%%-multiselect-editor
 */
export class ZeroMultiselectEditor extends MultiselectEditor {
}
/**
 * The Zero Multiselect editor
 *
 * @public
 * @remarks
 * HTML Element: \<zero-multiselect-editor\>
 */
export const zeroAgMultiselectEditor = ZeroMultiselectEditor.compose({
    baseName: 'multiselect-editor',
    styles: agMultiselectEditorStyles,
    template: getMultiselectEditorTemplate('zero'),
});
